import { render, staticRenderFns } from "./Faults.vue?vue&type=template&id=f5e50d50&scoped=true"
import script from "./Faults.vue?vue&type=script&lang=js"
export * from "./Faults.vue?vue&type=script&lang=js"
import style0 from "./Faults.vue?vue&type=style&index=0&id=f5e50d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e50d50",
  null
  
)

export default component.exports